export namespace RideWssAppConstants {
  export const APPLICATION_VERSION: string = 'V1.0';
}
